import { BackgroundValues } from '@stories/Components/Breadcrumb/Breadcrumb';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import * as React from 'react';
import S from './EmbeddedPdfLink.styles';
const EmbeddedPdfLink = ({ anchorId, background, pdfTitle, pdfUrl, }) => {
    return (React.createElement(S.Container, { id: anchorId, "data-background": background && background !== '' ? background : BackgroundValues.White },
        React.createElement(S.IframeWrapper, null,
            React.createElement(S.Iframe, { loading: "lazy", src: pdfUrl, title: pdfTitle })),
        React.createElement(CtaLink, { href: pdfUrl, target: "_blank" },
            "View ",
            pdfTitle)));
};
export default EmbeddedPdfLink;
